import { useMemo } from "react";
import { DateTime } from "luxon";

/** Jobs created from this moment use the newer part orders (`jobItem`); older ones the legacy `orderItem`. */
export const isMultiplePartOrdersJob = (jobCreatedAt?: string | null): boolean => {
  if (!jobCreatedAt) return false;

  const date = DateTime.fromObject({
    year: 2025,
    month: 8,
    day: 12,
    hour: 19,
    minute: 30,
  });

  const jobDate = DateTime.fromISO(jobCreatedAt);

  return jobDate >= date;
};

export const useMultiplePartOrders = (jobCreatedAt?: string | null): boolean =>
  useMemo(() => isMultiplePartOrdersJob(jobCreatedAt), [jobCreatedAt]);
